import React, { useState } from 'react';
import EssentialVocabularyExercise from './EssentialVocabularyExercise';
import './EssentialVocabularyExerciseBoard.css';

const ESSENTIAL_VOCABULARY_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #111827 0%, #374151 100%)', marginRight: 20
  }}>
    <svg width="28" height="28" viewBox="0 0 16 16" fill="white">
      <path d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.18.18 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.18.18 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.18.18 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.18.18 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.18.18 0 0 0 .134-.098z"/>
      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z"/>
    </svg>
  </span>
);

const EssentialVocabularyExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { vocabulary, title, level } = exerciseData;

  if (!vocabulary || !Array.isArray(vocabulary)) {
    return (
      <div className="essential-vocabulary-board-error">
        <p>Error: Invalid Essential Vocabulary exercise data</p>
      </div>
    );
  }

  return (
    <div className="essential-vocabulary-exercise-board">
      {!isExpanded ? (
        <div
          className={`essential-vocabulary-preview unified-exercise-preview ev-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {ESSENTIAL_VOCABULARY_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Essential Vocabulary Exercise'}</div>
            <div className="unified-preview-meta">
              {vocabulary.length} vocabulary items · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="essential-vocabulary-expanded">
          <EssentialVocabularyExercise
            vocabulary={vocabulary}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            updateAttributes={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default EssentialVocabularyExerciseBoard; 